<div class="view-layers-slider" #slider>

  <div class="view-layers-slider__track" (click)="handleTrackClick($event)" #track>
    <div class="view-layers-slider__bar" #bar></div>
  </div>

  <div
    #handle
    class="view-layers-slider__handle"
    cdkDrag
    cdkDragLockAxis="x"
    cdkDragBoundary=".view-layers-slider"
    [cdkDragFreeDragPosition]="dragPosition"
    (cdkDragEnded)="handleDragEnded()"
    (cdkDragMoved)="handleDragMoved($event)"
    [ngClass]="{'view-layers-slider__handle-touch': canTouch$ | async }"
    matTooltip="{{ currentLayerName }}"></div>

</div>